import { Injectable } from '@angular/core';
import type { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { DepartmentActions } from '@core/department-data';
import { RequisitionAssignmentsActions, AssignedFlowsActions } from '@recruitee/requisitions-data';
import { RequisitionsConfigActions } from '@recruitee/requisitions-settings-data';

@Injectable()
export class RequisitionRootResolver {
  constructor(
    private store: Store,
    private actions$: Actions,
    private router: Router,
  ) {}

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const id = route.params.id;

    this.store.dispatch(RequisitionsConfigActions.fetch());
    this.store.dispatch(RequisitionAssignmentsActions.fetchOne({ payload: { id } }));
    this.store.dispatch(DepartmentActions.fetchCollection());
    this.store.dispatch(AssignedFlowsActions.fetch({ payload: { requisitionId: id } }));

    return true;
  }
}
